module.exports = __webpack_public_path__ + "static/img/纹理.cbe4943e.png";